import DateSeparator from './DateSeparator';

export default DateSeparator;
